import { Alert, Spin } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { openNotification } from "../../../components/Notification";
import { menuIndicadorService } from "../../../services/resources/menuIndicadorService";

export const DestinoIndicador = () => {
  const { codigo } = useParams();
  const [erro, setErro] = useState(null);

  useEffect(() => {
    let cancelado = false;
    async function abrir() {
      try {
        const { data } = await menuIndicadorService.destino(codigo);
        if (!cancelado && data?.url) {
          window.location.replace(data.url);
        }
      } catch (error) {
        if (cancelado) return;
        const status = error?.response?.status;
        if (status === 403) {
          setErro("Você não possui permissão para acessar este indicador.");
        } else if (status === 404) {
          setErro("Indicador não encontrado ou inativo.");
        } else {
          setErro(
            error?.response?.data?.userMessage ||
              "Não foi possível abrir o indicador."
          );
        }
        openNotification(
          "error",
          <strong>Acesso ao indicador</strong>,
          error?.response?.data?.userMessage
        );
      }
    }
    abrir();
    return () => {
      cancelado = true;
    };
  }, [codigo]);

  if (erro) {
    return (
      <div id="sectionMain">
        <Alert type="error" showIcon message="Acesso negado" description={erro} />
      </div>
    );
  }

  return (
    <div id="sectionMain">
      <Spin tip="Redirecionando..." />
    </div>
  );
};
